import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useEffect, useRef } from 'react';
import { useSubscription } from '@meraki-internal/state';
import { ChartLineAndChartActiveElementSynchronizer } from './ChartLineAndChartActiveElementSynchronizer';
import { ChartTooltipConfig } from './ChartTooltip';
import { ChartJSProvider } from './ChartJSProvider';

// TODO: can we add vertical padding to chart, such that we can "move" our tooltip?
export const ChartTooltipLine: React.FC = () => {
    const { backgroundColor } = useInstance(ChartTooltipConfig);
    const chartJSProvider = useInstance(ChartJSProvider);

    if (!chartJSProvider.activeElementObserver){
        throw new Error('<ChartTooltip> was rendered before ChartJSProvider was set');
    }
    useSubscription(() => chartJSProvider.activeElementObserver!);

    const canvasRef = useRef<HTMLCanvasElement>(null);

    useEffect(() => {
        return new ChartLineAndChartActiveElementSynchronizer(
            canvasRef.current!,
            getComputedStyle(document.body).getPropertyValue(backgroundColor),
            chartJSProvider.activeElementObserver!
        ).synchronize();
    }, [backgroundColor, chartJSProvider.activeElementObserver]);

    useEffect(() => {
        const observer = new ResizeObserver(() => {
            if (canvasRef.current){
                canvasRef.current.height = chartJSProvider.getCanvas().clientHeight;
                canvasRef.current.width = chartJSProvider.getCanvas().clientWidth;
            }
        });
        observer.observe(chartJSProvider.getCanvas());
        return () => {
            observer.disconnect();
        };
    }, [canvasRef, chartJSProvider]);

    return (
        <canvas ref={canvasRef} style={{

            // position on top of the chartjs chart
            position: 'absolute',

            // useful for verifying it is still where it should be
            // border: 'solid 1px black',

            // behind the chart so interactions are with the chart
            zIndex: -1
        }} />
    );
};
